import React from "react";
import styles from "./styles.module.scss";
import { UmbracoImage } from "@components/Image/UmbracoImage/UmbracoImage";
import { ImageField } from "@helpers/interfaces/image";
import { Link } from "@components/Link/Link";
import { Text } from "@components/Text/Text";
import { Icon } from "@components/Icon/Icon";
import downloadIcon from "@svg-icons/download.component.svg";
import { AspectRatio } from "@components/AspectRatio/AspectRatio";
import { Box } from "@components/Box/Box";

interface MediaProp extends ImageField {
  UmbracoFile: string;
  Name: string;
}
export interface DownloadBoxProps {
  Media: MediaProp;
  ShowImage?: ImageField;
  Key?: string;
}

const DownloadBox: React.FC<DownloadBoxProps> = ({
  Media,
  ShowImage,
  ...props
}) => {
  const isMediaImage =
    !ShowImage &&
    (Media.UmbracoExtension === "jpg" ||
      Media.UmbracoExtension === "jpeg" ||
      Media.UmbracoExtension === "png" ||
      Media.UmbracoExtension === "gif" ||
      Media.UmbracoExtension === "svg");
  return (
    <Link
      href={Media.FullUrl ? Media.FullUrl : Media.Url}
      className={styles.downloadBox}
      download={true}
      {...props}
    >
      {isMediaImage ? (
        <Box className={styles.downloadBoxImg}>
          <UmbracoImage image={Media} width={[375, 320, 200, 300]} isCover />
          <Icon svg={downloadIcon} className={styles.downloadIcon} />
        </Box>
      ) : (
        <>
          {ShowImage ? (
            <Box>
              <UmbracoImage
                image={ShowImage}
                width={[375, 320, 200, 300]}
                isCover
              />
              <Icon svg={downloadIcon} className={styles.downloadIcon} />
            </Box>
          ) : (
            <AspectRatio ratio="16:9" className={styles.downloadBoxImg}>
              <Icon svg={downloadIcon} className={styles.downloadIcon} />
            </AspectRatio>
          )}
        </>
      )}

      <Text className={styles.downloadName}>{Media.Name}</Text>
    </Link>
  );
};

DownloadBox.defaultProps = {};

export { DownloadBox };
